import React from 'react'

import WidgetContainer from '../../../components/atoms/WidgetContainer'
import OpenConvos from './HeaderWidgets/OpenConvos'
import ClosedToday from './HeaderWidgets/ClosedToday'
import OpenConversations from './BodyWidgets/OpenConversations'
import ConversationsPerDay from './BodyWidgets/ConversationsPerDay'

import useAccess, { PERMS } from '../../../hooks/useAccess'

const ConversationsTab: React.FC = () => {
  const hasPermission = useAccess()

  const canViewConvos = React.useMemo(
    () => hasPermission(PERMS.ConversationsBasic),
    [hasPermission]
  )

  return (
    <>
      <WidgetContainer variant='header' visible={canViewConvos}>
        {canViewConvos && (
          <>
            <OpenConvos />

            <ClosedToday />
          </>
        )}
      </WidgetContainer>

      <WidgetContainer variant='body' visible={canViewConvos}>
        {canViewConvos && (
          <>
            <OpenConversations />

            <ConversationsPerDay />
          </>
        )}
      </WidgetContainer>
    </>
  )
}

export default ConversationsTab
